<template>
  <div class="filter-providers">
    <div class="filter-providers__headline">
      <UiText
        :text="data.title"
        tag="h3"
        font="promo-heading-3"
        bold
        color="typography-title01"
        align-center
      />
    </div>

    <form @submit.prevent="validateText">
      <BaseInputSearch
        ref="searchRef"
        v-model="searchValue"
        :placeholder="$tc('lobby.filter.providerPlaceholder')"
        type="text"
        :error-messages="errorSearch"
        @blur="validateText"
        @input="errorSearch = []"
        @focus="scrollTo"
      />
    </form>

    <div
      class="filter-providers__list"
      @touchstart="scrollTo"
    >
      <button
        v-for="item in searchingProviders"
        :key="item.code"
        class="filter-providers__item"
        :class="{ 'active': item[item.code] }"
        @click="item[item.code] = !item[item.code]"
      >
        <img
          class="filter-providers__item-logo"
          :src="`${$config.cloudUrl}${item.iconUrl}`"
          width="28"
          height="28"
          alt="provider logo"
        />

        <UiText
          :text="item.name"
          tag="span"
          font="body-text-small"
          color="typography-title01"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseInputSearch from '~/components/Base/Input/Search'
import { validationMixin } from 'vuelidate'
import { minLength } from 'vuelidate/lib/validators'

const MIN_LENGTH_INPUT = 3

export default {
  name: 'FilterProviders',
  components: {
    BaseInputSearch,
  },
  mixins: [validationMixin],
  props: {
    data: { type: Object, required: true },
  },
  data() {
    return {
      searchValue: '',
      mutadetFilters: [],
      errorSearch: [],
    }
  },
  validations() {
    return {
      searchValue: {
        minLength: minLength(MIN_LENGTH_INPUT),
      },
    }
  },
  computed: {
    ...mapGetters('lobby', [
      'get_filterOptions',
    ]),
    selectedFilter() {
      const selectedProviders = this.mutadetFilters.filter(f => f[f.code])
        .map(m => m.code)
        .join(',')

      return {
        providers: selectedProviders,
      }
    },
    providerData() {
      const [ providerData ] = this.data.data
      if (!providerData) return []
      return providerData
    },
    searchingProviders() {
      const l = (text) => text.toLowerCase()

      if (this.$v.searchValue.minLength) {
        return this.mutadetFilters.filter(el =>{
          return l(el.name).includes(l(this.searchValue))
            || l(el.code).includes(l(this.searchValue))
            || el[el.code]
        })
      }
      return this.mutadetFilters
    },
  },
  watch: {
    'selectedFilter': {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true,
    },
    searchingProviders(val) {
      if (this.searchValue.length >= MIN_LENGTH_INPUT && !val.length) {
        this.errorSearch.push(this.$tc('lobby.filter.emptyProviders'))
      }
      else {
        this.errorSearch = []
      }
    },
  },
  mounted() {
    const { filterProviders } = this.get_filterOptions.selected
    this.initFilters(filterProviders)
  },
  beforeDestroy() {
    this.searchValue = ''
  },
  methods: {
    scrollTo() {
      const el = document.querySelector('.filter-list__scroll-content')
      const searchEl = this.$refs.searchRef?.$el

      el?.scrollTo({
        top: searchEl?.offsetTop - 16,
        behavior: 'smooth',
      })
    },
    initFilters(value) {
      this.mutadetFilters = this.providerData?.providers.map((el) => {
        return {
          ...el,
          label: el.labels[0],
          [el.code]: value?.providers?.includes(el.code),
        }
      })
    },
    validateText() {
      this.$v.searchValue.$touch()

      if (!this.$v.searchValue.minLength) {
        this.errorSearch = []
        this.errorSearch.push(this.$tc('lobby.filter.needThreeSymbols'))
      }
      return []
    },
    reset() {
      this.searchValue = ''
      this.initFilters({})
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
